// frontend/src/modules/reports/pages/workforce/registry.ts
//
// Phase 4 (Reports Frontend). Workforce-family report registry. OWNERSHIP:
// Task 1 seeds this with the hours-summary reference entry; Tasks 2/3 APPEND
// ONLY (exceptions, overtime, idle-breaks, timeline, live-roster, leave) —
// never edit another lane's registry or pages (see reports/registry.ts).
//
// Gating matrix (mirrors the backend requireFamily() stacks in
// api/modules/reports/routes.ts verbatim):
//   hours-summary / exceptions / overtime / idle-breaks / timeline
//     -> hr.attendance.view_all + module 'hr'
//   live-roster
//     -> monitoring.view_all + module 'monitoring'
//   leave
//     -> hr.leave.view_all + module 'hr'

import type { ReportRegistryEntry } from '../../registry';
import { HoursSummaryPage } from './HoursSummaryPage';
import { ExceptionsPage } from './ExceptionsPage';
import { OvertimePage } from './OvertimePage';
import { LiveRosterPage } from './LiveRosterPage';
import { IdleBreaksPage } from './IdleBreaksPage';
import { LeaveReportPage } from './LeaveReportPage';
import { TimelinePage } from './TimelinePage';

export const workforceReportsRegistry: ReportRegistryEntry[] = [
  {
    key: 'hours-summary',
    title: 'Hours summary',
    description: 'Scheduled vs. worked and active hours per employee.',
    permissions: ['hr.attendance.view_all'],
    modules: ['hr'],
    component: HoursSummaryPage,
  },
  {
    key: 'exceptions',
    title: 'Exceptions',
    description: 'Late, missed, short-day, and early-departure attendance exceptions.',
    permissions: ['hr.attendance.view_all'],
    modules: ['hr'],
    component: ExceptionsPage,
  },
  {
    key: 'overtime',
    title: 'Overtime',
    description: 'Minutes worked beyond expectation per employee, by day or week.',
    permissions: ['hr.attendance.view_all'],
    modules: ['hr'],
    component: OvertimePage,
  },
  {
    key: 'live-roster',
    title: 'Live roster',
    description: "Who's working right now, and their agent's connectivity.",
    permissions: ['monitoring.view_all'],
    modules: ['monitoring'],
    component: LiveRosterPage,
  },
  {
    key: 'idle-breaks',
    title: 'Idle & breaks',
    description: 'Break and idle time per employee, alongside active minutes.',
    permissions: ['hr.attendance.view_all'],
    modules: ['hr'],
    component: IdleBreaksPage,
  },
  {
    key: 'leave',
    title: 'Leave',
    description: 'Leave requests and per-employee balances.',
    permissions: ['hr.leave.view_all'],
    modules: ['hr'],
    component: LeaveReportPage,
  },
  {
    key: 'timeline',
    title: 'Timeline',
    description: "A single employee's day: sessions, pauses, and time entries.",
    permissions: ['hr.attendance.view_all'],
    modules: ['hr'],
    component: TimelinePage,
  },
];
